import { render, staticRenderFns } from "./NotificationsTable.vue?vue&type=template&id=ebe9c104&scoped=true&"
import script from "./NotificationsTable.vue?vue&type=script&lang=js&"
export * from "./NotificationsTable.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsTable.vue?vue&type=style&index=0&id=ebe9c104&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe9c104",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebe9c104')) {
      api.createRecord('ebe9c104', component.options)
    } else {
      api.reload('ebe9c104', component.options)
    }
    module.hot.accept("./NotificationsTable.vue?vue&type=template&id=ebe9c104&scoped=true&", function () {
      api.rerender('ebe9c104', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/alerts/NotificationsTable.vue"
export default component.exports